import { getSubmissionList, checkEligibility } from '~/api/mitra-peduli';

export const state = () => ({
  submissionList: [],
  submission: {},
});

export const getters = {
  getSubmissionList: state => state.submissionList,
  getSubmission: state => state.submission,
};

export const mutations = {
  setSubmissionList(state, submissionList) {
    state.submissionList = submissionList;
  },
  setSubmission(state, submission) {
    state.submission = submission;
  },
};
export const actions = {
  async fetchSubmissionList({ commit }) {
    const response = await getSubmissionList(this.$axios);
    commit('setSubmissionList', response.data);
  },
  setSubmission({ commit }, submission) {
    commit('setSubmission', submission);
  },
  async checkEligibility(context, payload) {
    return checkEligibility(this.$axios, payload);
  },
};
